export default function initCSPEmails() {
    document.querySelectorAll('[data-csp-email]').forEach(el => {
        el.addEventListener('click', function (e) {
            e.preventDefault();

            const data = this.dataset.cspEmail;
            if (!data) return;

            const [encoded, offsetStr] = data.split(',');
            const offset = parseInt(offsetStr, 10);

            if (encoded && !isNaN(offset)) {
                linkTo_UnCryptMailto(encoded, offset);
            } else {
                console.warn('Invalid data-csp-email format:', data);
            }
        });
    });
}
